/**
 * Subscribe & Save / Air Guide FAQ accordion
 */
(function () {
  function initSubscribeSaveFaqDelegation() {
    if (document.body.dataset.ssFaqDelegation === "1") return;
    document.body.dataset.ssFaqDelegation = "1";
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var faqBtn = t.closest("[data-faq-q]");
      if (!faqBtn || !faqBtn.closest("[data-ss-faq]")) return;
      e.preventDefault();
      var faqRoot = faqBtn.closest("[data-ss-faq]");
      if (!faqRoot) return;
      var ans = faqBtn.nextElementSibling;
      var open = faqBtn.getAttribute("aria-expanded") === "true";
      faqRoot.querySelectorAll("[data-faq-q]").forEach(function (q) {
        q.setAttribute("aria-expanded", "false");
        var a = q.nextElementSibling;
        if (a) a.setAttribute("hidden", "");
      });
      if (!open && ans) {
        faqBtn.setAttribute("aria-expanded", "true");
        ans.removeAttribute("hidden");
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSubscribeSaveFaqDelegation);
  } else {
    initSubscribeSaveFaqDelegation();
  }
})();
